import { render, staticRenderFns } from "./FlowsComponent.vue?vue&type=template&id=1e534116&scoped=true"
import script from "./FlowsComponent.vue?vue&type=script&lang=js"
export * from "./FlowsComponent.vue?vue&type=script&lang=js"
import style0 from "./FlowsComponent.vue?vue&type=style&index=0&id=1e534116&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e534116",
  null
  
)

export default component.exports